/**
 * @module IDEE/style/pattern
 */

/**
 * Patrón de estilo de sombreado.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const HATCH = 'HATCH';

/**
 * Patrón de estilo cruzado.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CROSS = 'CROSS';

/**
 * Patrón de estilo de punto.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const DOT = 'DOT';

/**
 * Patrón de estilo de círculo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CIRCLE = 'CIRCLE';

/**
 * Patrón de estilo cuadrado.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const SQUARE = 'SQUARE';

/**
 * Patrón de estilo de mosaico.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const TILE = 'TILE';

/**
 * Patrón de estilo tejido.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const WOVEN = 'WOVEN';

/**
 * Patrón de estilo de cruces.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CROSSES = 'CROSSES';

/**
 * Patrón de estilo de gorras.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CAPS = 'CAPS';

/**
 * Patrón de estilo de nailon.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const NYLON = 'NYLON';

/**
 * Patrón de estilo hexagonal.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const HEXAGON = 'HEXAGON';

/**
 * Patrón de estilo cementerio.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CEMETRY = 'CEMETRY';

/**
 * Patrón de estilo arena.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const SAND = 'SAND';

/**
 * Patrón de estilo conglomerado.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CONGLOMERATE = 'CONGLOMERATE';

/**
 * Patrón de estilo de grava.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const GRAVEL = 'GRAVEL';

/**
 * Patrón de estilo de ladrillo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const BRICK = 'BRICK';

/**
 * Patrón de estilo dolomita.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const DOLOMITE = 'DOLOMITE';

/**
 * Patrón de estilo carbón.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const COAL = 'COAL';

/**
 * Patrón de estilo "Brevvia".
 * @const
 * @type {string}
 * @public
 * @api
 */
export const BRECCIA = 'BRECCIA';

/**
 * Patrón de estilo de arcilla.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CLAY = 'CLAY';

/**
 * Patrón de estilo inundado.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const FLOODED = 'FLOODED';

/**
 * Patrón de estilo caos.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CHAOS = 'CHAOS';

/**
 * Patrón de estilo de hierba.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const GRASS = 'GRASS';

/**
 * Patrón de estilo pantano.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const SWAMP = 'SWAMP';

/**
 * Patrón de estilo de onda.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const WAVE = 'WAVE';

/**
 * Patrón de estilo de vid.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const VINE = 'VINE';

/**
 * Patrón de estilo bosque.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const FOREST = 'FOREST';

/**
 * Patrón de estilo de matorral.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const SCRUB = 'SCRUB';

/**
 * Patrón de estilo de árbol.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const TREE = 'TREE';

/**
 * Patrón de estilo pino.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const PINE = 'PINE';

/**
 * Patrón de estilo de pinos.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const PINES = 'PINES';

/**
 * Patrón de estilo de roca.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const ROCK = 'ROCK';

/**
 * Patrón de estilo de rocas.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const ROCKS = 'ROCKS';

/**
 * Patrón de estilo de carácter.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const CHARACTER = 'CHARACTER';

/**
 * Patrón de estilo de icono.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const ICON = 'ICON';

/**
 * Patrón de estilo de imagen.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const IMAGE = 'IMAGE';
